module.exports = __webpack_public_path__ + "static/media/game-controller@3x.1075ec9c.png";